const articleContract = Object.seal({
  id: '',
  headline: '',
  url: '',
  isCommentsEnabled: true
});

function validateArticle(article) {
  if (typeof article.url !== 'string') {
    throw Error(`Article url should be string, received ${typeof article.url}`);
  }
  if (typeof article.id !== 'string') {
    throw Error(`Article id should be string, received ${typeof article.id}`);
  }
  return true;
}

function createArticle(article) {
  const isValid = validateArticle(article);

  if (isValid) {
    return Object.assign(articleContract, article);
  }
}

export {createArticle};
